import React from 'react';
export function SolutionSection() {
  return <section className="w-full py-16 px-4 bg-gradient-to-b from-white to-cream" data-id="element-112">
      <div className="max-w-4xl mx-auto text-center" data-id="element-113">
        <p className="font-heading text-2xl text-gray-700 mb-6" data-id="element-114">
          Por eso creé:
        </p>

        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-2xl border-4 border-primary" data-id="element-115">
          <h2 className="font-heading font-bold text-4xl md:text-5xl text-primary mb-6" data-id="element-116">
            🧶 MÉTODO CREA CON HILOS
          </h2>

          <p className="font-body text-xl md:text-2xl text-gray-800 leading-relaxed" data-id="element-117">
            Un sistema paso a paso diseñado para que cualquier persona pueda
            aprender crochet desde cero y lograr resultados reales sin
            frustrarse.
          </p>
        </div>
      </div>
    </section>;
}